import { map, flatMap } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { DataService, ApiService, InspectionPluginService } from '../../shared/services/index';
import { InspectionPlugin } from '../../shared/models/index';
import { InspectionFactoryService } from '../../shared/services/inspectionFactory.service';

@Injectable()
export class RecommendedPartsPluginService extends InspectionPluginService {
  constructor(protected apiService: ApiService, protected dataService: DataService, factory: InspectionFactoryService) {
    super(apiService, dataService, null, factory);
  }

  public updateRecommendedParts(inspectionId: string, pluginId: string, data: any): Observable<any> {
    return this.update(inspectionId, pluginId, data).pipe(
      map((res: InspectionPlugin) => {
        return this.dataService.updatePlugin(inspectionId, res);
      })
    );
  }

  private update(inspectionId: string, pluginId: string, data: any): Observable<any> {
    return this.factory.updatePluginConfig(inspectionId, null, pluginId, data, null).pipe(
      flatMap((plugin) => {
        if (this.isInspectionInOffline(inspectionId)) {
          return of(plugin);
        }
        return this.apiService.post(plugin.postServerUrl, plugin.config);
      })
    );
  }
}
